import { useAccountTypeStructures } from "../../../hooks/useAccountTypeStructures";
import { CASH_BOX_ACCOUNT_TYPE } from "./cash-boxes.constants";

export function useCashBoxStructures() {
  return useAccountTypeStructures(CASH_BOX_ACCOUNT_TYPE);
}
